import _ from 'lodash';
import LockIcon from '@material-ui/icons/LockOpen';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import momentTz from 'moment-timezone';
import { GREEN, LANGUAGES, PERMISSIONS, PERMISSION_ENTITIES } from '../../../_config/consts.js';
import AbilityProvider from '../../../permissionsUtils/AbilityProvider.js';
import TimezoneIconCustom from '../../CustomIcons/TimezoneIconCustom.jsx';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';
import TagsSelectorListField from '../Elements/TagsSelectorListField.jsx';
import MDCheckBoxField from '../Fields/MDCheckBox/MDCheckBoxField.js';
import MDSwitchView from '../Fields/MDSwitch/MDSwitchView.jsx';
import SelectableField from '../Fields/SelectableInput/SelectableField.jsx';
import CustomField from '../Fields/CustomField.jsx';

const validate = values => {
  const errors = {};

  if (!values.properties || !values.properties.length) {
    errors.properties = 'required';
  }

  return errors;
};

@reduxForm({ form: 'OpertoSelectPropertiesForm', validate })
@connect(state => ({
  form: state.form.OpertoSelectPropertiesForm,
  language: state.settings.language,
}))
class OpertoSelectPropertiesForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      timezones: momentTz.tz.names(),
      guessedTimezone: momentTz.tz.guess(),
      showTimezoneSelector: false,
    };
  }

  componentDidMount() {
    const { guessedTimezone } = this.state;
    const { dispatch } = this.props;
    dispatch(change('OpertoSelectPropertiesForm', 'timezone', guessedTimezone));
  }

  onFilterTimezones(value) {
    const timezones = momentTz.tz.names().filter(timezone => timezone.toLowerCase().includes(value.toLowerCase()));
    this.setState({ timezones });
  }

  onSelectTimezone(selectedOption) {
    const { dispatch } = this.props;
    const selectedTimezone = selectedOption && selectedOption.value ? selectedOption.value : momentTz.tz.guess();
    dispatch(change('OpertoSelectPropertiesForm', 'timezone', selectedTimezone));
    this.setState({ guessedTimezone: selectedTimezone });
  }

  onUseReservationCheckInCheckOutTimeChange(checked) {
    const { dispatch } = this.props;
    if (checked) {
      dispatch(change('OpertoSelectPropertiesForm', 'checkInTimeOverride', undefined));
      dispatch(change('OpertoSelectPropertiesForm', 'checkOutTimeOverride', undefined));
    }
  }

  render() {
    const {
      properties,
      availableLockTags,
      locksFilteredByTags,
      form,
      onLockInputChange,
      onLockTagsChange,
      onLockFilterModeChange,
      onFetchMoreLocks,
      language,
    } = this.props;

    const { guessedTimezone, showTimezoneSelector, timezones } = this.state;
    const is12HoursFormat = language === LANGUAGES.ENGLISH;

    const propertiesOptions = _.map(properties, property => ({
      value: property.id,
      label: property.name,
    }));

    const canReadLock = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.SMART_LOCK);
    const useReservationCheckInCheckOutTime = form && form.values && form.values.useReservationCheckInCheckOutTime;

    return (
      <div>
        <h4 style={{ color: '#3f3f3f', textAlign: 'start', marginTop: 10, marginBottom: 10, fontWeight: 'bold' }}>
          <Entity entity="opertoSelectPropertiesTitle" />
        </h4>
        <h4 style={{ color: '#3f3f3f', textAlign: 'start', marginTop: 0, marginBottom: 20, fontSize: '1.1em' }}>
          <Entity entity="opertoSelectPropertiesSubtitle" />
        </h4>
        <Field
          name="properties"
          component={SelectableField}
          title={<Entity entity="opertoProperties" />}
          placeholder={<Entity entity="opertoSelectPropertiesPlaceholder" />}
          options={propertiesOptions}
          multi
          mandatory
          containerstyle={{ width: '100%', marginBottom: 20 }}
        />
        {guessedTimezone ? (
          <div>
            <h4 style={{ fontWeight: 'bold', fontSize: 16, marginTop: 20 }}>
              <Entity entity="buildingTimeZone" />
            </h4>
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: 10, paddingLeft: 15, borderRadius: 10, background: '#f0f0f0' }}>
              <TimezoneIconCustom style={{ width: 20, marginRight: 10 }} />
              <h5 style={{ fontWeight: 'bold', fontSize: 16 }}>{guessedTimezone}</h5>
            </div>
            <MDSwitchView
              label={<Entity key={showTimezoneSelector} entity="notYourTimeZone" />}
              checked={showTimezoneSelector}
              titleStyle={{ fontWeight: showTimezoneSelector ? 'bold' : 'normal', color: showTimezoneSelector ? GREEN : '#3f3f3f' }}
              onSelect={selected => this.setState({ showTimezoneSelector: selected })}
            />
          </div>
        ) : null}
        {showTimezoneSelector ? (
          <Field
            name="timezone"
            title={<Entity entity="selectTimezone" />}
            component={SelectableField}
            options={_.map(timezones, timezone => ({ value: timezone, label: timezone }))}
            titleStyle={{ fontSize: 16 }}
            placeholder={<Entity entity="search" />}
            containerstyle={{ width: '100%', marginBottom: 20 }}
            onInputChange={value => this.onFilterTimezones(value)}
            onSelect={value => this.onSelectTimezone(value)}
          />
        ) : null}
        <FormFlatContainer
          title="opertoCommonLockTagsTitle"
          subtitle="opertoCommonLockTagsSubtitle"
          containerStyle={{ marginRight: 10 }}
          icon={<LockIcon style={{ fontSize: 22, marginTop: 2, marginRight: 2 }} />}
        >
          <TagsSelectorListField
            formName="OpertoSelectPropertiesForm"
            name="lockTags"
            selectorFieldName="lockTagMatchingMode"
            selectedTagsFieldName="selectedLocksTags"
            tags={availableLockTags.filter(e => e.type !== 'private_unit')}
            selectedTags={locksFilteredByTags && locksFilteredByTags[0]}
            form={form}
            tagsType="LOCK"
            title="lockTags"
            placeholder="insertLockTagsForPrivateUnit"
            listTitle="selectedLocks"
            emptyTagSelectionText={canReadLock ? 'noLocksSelectedWithTag' : null}
            onFetchMoreItems={page => onFetchMoreLocks(page)}
            onTagsChange={values => onLockTagsChange(values)}
            onInputChange={value => onLockInputChange(value)}
            onFilterModeChange={value => onLockFilterModeChange(value)}
            isOptional={true}
          />
        </FormFlatContainer>
        <FormFlatContainer
          title="opertoCheckInCheckOutSettingsTitle"
          subtitle="opertoCheckInCheckOutSettingsDescription"
          containerStyle={{ marginTop: 20, marginRight: 0 }}
        >
          <div style={{ opacity: useReservationCheckInCheckOutTime ? 0.5 : 1 }}>
            <Field
              name="checkInTimeOverride"
              title={<Entity entity="opertoCheckInTimeOverride" />}
              component={CustomField}
              type="antdTimePicker"
              is12HoursFormat={is12HoursFormat}
              disabled={useReservationCheckInCheckOutTime}
              containerStyle={{ marginBottom: 15 }}
            />
            <Field
              name="checkOutTimeOverride"
              title={<Entity entity="opertoCheckOutTimeOverride" />}
              component={CustomField}
              type="antdTimePicker"
              is12HoursFormat={is12HoursFormat}
              disabled={useReservationCheckInCheckOutTime}
            />
          </div>
          <Field
            name="useReservationCheckInCheckOutTime"
            label={<Entity entity="opertoUseReservationCheckInCheckOutTime" />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
            containerstyle={{ marginTop: 15 }}
            onHandleChange={checked => this.onUseReservationCheckInCheckOutTimeChange(checked)}
          />
        </FormFlatContainer>
        <FormFlatContainer
          title="opertoColdStartTitle"
          subtitle="opertoColdStartDescription"
          containerStyle={{ marginTop: 20, marginRight: 0 }}
        >
          <Field
            name="coldStart"
            label={<Entity entity="opertoColdStartEnabled" />}
            titleStyle={{ fontSize: 16, color: '#3f3f3f' }}
            component={MDCheckBoxField}
          />
        </FormFlatContainer>
      </div>
    );
  }
}

export default OpertoSelectPropertiesForm;
